import React from 'react'
import '../assets/css/components/work-product-quality-progress-bar.css'

interface PercentageType {
	incompletePercentage: number
	greatStrugglePercentage: number
	strugglePercentage: number
	noStrugglePercentage: number
}

const WorkProductQuailityProgressBar = ({
	incompletePercentage,
	greatStrugglePercentage,
	strugglePercentage,
	noStrugglePercentage
}: PercentageType) => {
	const incompleteInt = Math.round(incompletePercentage * 100)
	const greatStruggleInt = Math.round(greatStrugglePercentage * 100)
	const struggleInt = Math.round(strugglePercentage * 100)
	const noStruggleInt = Math.round(noStrugglePercentage * 100)

	return (
		<div className='work-product-quality-progress-bar'>
			{incompleteInt > 0 && (
				<span className='pe-bar incomplete' style={{ width: `${incompleteInt}%` }}>
					<span className='pe-percentage'>{incompleteInt}%</span>
				</span>
			)}
			{greatStruggleInt > 0 && (
				<span className='pe-bar great-struggle' style={{ width: `${greatStruggleInt}%` }}>
					<span className='pe-percentage'>{greatStruggleInt}%</span>
				</span>
			)}
			{struggleInt > 0 && (
				<span className='pe-bar struggle' style={{ width: `${struggleInt}%` }}>
					<span className='pe-percentage'>{struggleInt}%</span>
				</span>
			)}
			{noStruggleInt > 0 && (
				<span className='pe-bar no-struggle' style={{ width: `${noStruggleInt}%` }}>
					<span className='pe-percentage'>{noStruggleInt}%</span>
				</span>
			)}
		</div>
	)
}

export default WorkProductQuailityProgressBar
